/*
 * @author: https://www.51xuediannao.com/
 * @update: 2021-09-23 12:02
 */

import {createApp} from 'vue'
import App from './App.vue'
import {router} from './router/index'
import {util} from './common/util'
import {store} from './store/store';

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn' // 引入中文语言包
// import enCn from 'element-plus/es/locale/lang/en' // 引入英文语言包

//本地国际化语言文件
// import {i18n} from './locales/i18n';

//网络请求国际化语言文件
import {i18n} from './locales/i18nW';

import './css/style.dev.scss';
import websocket from './common/webSocket';

// 导航守卫文档：https://next.router.vuejs.org/zh/guide/advanced/navigation-guards.html#%E5%85%A8%E5%B1%80%E8%A7%A3%E6%9E%90%E5%AE%88%E5%8D%AB
const whiteList = ['/login','/datav/all','/loginSelect','/loginEmployee']
router.beforeEach((to, from, next) => {
    if(whiteList.indexOf(to.path) > -1){
        next()
    }else{
        if(!util.getLocalStorage('TOKEN')||!util.getLocalStorage('userInfo')){
            util.clearLocalStorage()
            next({path:'/loginSelect'})
        }else{
            next()
        }
    }
})

router.afterEach((to) => {
    if (to.meta.title) {
        document.title = i18n.global.t(to.meta.title)
    }
})

const app = createApp(App)
app.use(store)
app.use(i18n)
app.use(router)
app.use(ElementPlus,{
    locale: zhCn,
})
app.config.globalProperties.$websocket = websocket;
app.mount('#app')
